module.exports = __webpack_public_path__ + "img/multi-reviews-carousel-all.f7d23e59.png";